export enum GeoCoordinatesApiUrls {
    ConvertAddressToLatLng='/api/DistanceTime/ConvertAddressToLatLng',
  }